var exports = {
  "Cd": "userButton__rLRaFg",
  "U0": "condensed__58TQ4v",
  "fA": "userContent__j12PRU",
  "dj": "userAvatar__JSLo0g",
  "vs": "upgradeLink__YmRtJo",
  "Ec": "planRow__tzCYUW",
  "pp": "footerAccountRow__yaBldD",
  "$7": "userNameButton__NIocKW",
  "Nd": "userTextColumn__C_u7bN",
  "j$": "menuItem__QD09oe",
  "yS": "userDetails__qG9xI_",
  "Xh": "username__B5YUoT",
  "h_": "description__g5TR5I",
  "GS": "planLabel__U09cBU",
};

module.exports = exports;
